import { render, staticRenderFns } from "./organization-listings.vue?vue&type=template&id=595d4e87&scoped=true&"
import script from "./organization-listings.vue?vue&type=script&lang=js&"
export * from "./organization-listings.vue?vue&type=script&lang=js&"
import style0 from "./organization-listings.vue?vue&type=style&index=0&id=595d4e87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595d4e87",
  null
  
)

export default component.exports